import UserStore from "./userStore";
import { createContext } from "react";
import { configure, makeAutoObservable } from "mobx";
import CommonStore from "./commonStore";
import ModalStore from "./modalStore";
import ListOfValoursStore from "./listOfValoursStore";
import ButtonLoadingStore from "./buttonLoadingStore";
import CompanyStore from "./companyStore";
import UserCompanyStore from "./userCompanyStore";
import BrokerStore from "./brokerStore";
import ClientStore from "./clientStore";
import SellerStorage from "./sellerStorage";
import PackageStore from "./packageStore";
import ReportStore from "./reportStore";

configure({ enforceActions: "always" });

export class RootStore {
  userStore: UserStore;
  commonStore: CommonStore;
  modalStore: ModalStore;
  listOfValours: ListOfValoursStore;
  buttonLoadingStore: ButtonLoadingStore;
  companyStore: CompanyStore;
  userCompanyStore: UserCompanyStore;
  brokerStore: BrokerStore;
  clienStore: ClientStore;
  sellerStore: SellerStorage;
  packageStore: PackageStore;
  reportStore: ReportStore;
  constructor() {
    makeAutoObservable(this);
    this.userStore = new UserStore(this);
    this.commonStore = new CommonStore(this);
    this.modalStore = new ModalStore(this);
    this.listOfValours = new ListOfValoursStore(this);
    this.buttonLoadingStore = new ButtonLoadingStore(this);
    this.companyStore = new CompanyStore(this);
    this.userCompanyStore = new UserCompanyStore(this);
    this.brokerStore = new BrokerStore(this);
    this.clienStore = new ClientStore(this);
    this.sellerStore = new SellerStorage(this);
    this.packageStore = new PackageStore(this);
    this.reportStore = new ReportStore(this);
  }
}

export const RootStoreContext = createContext(new RootStore());
